export const setEvent = (state, event) => {
  state.event = event;
};

export const removeTrainingGuest = (state, guestId) => {
  delete state.trainingGuests[guestId];
};

export const setTraining = (state, training) => {
  state.training = training;
};

export const setTrainingGuests = (state, trainingGuests) => {
  state.trainingGuests = trainingGuests;
};

export const setCompanyGuests = (state, companyGuests) => {
  state.companyGuests = companyGuests;
};

export const setCeo = (state, ceo) => {
  state.ceo = ceo;
};

export const setSavedGuests = (state, savedGuests) => {
  state.savedGuests = savedGuests;
};

export const setTrainingCeo = (state, trainingCeo) => {
  state.trainingCeo = trainingCeo;
};
